__webpack_require__.p = "https://static.age.awaze.com/postbook-auth-mfe/3b1bf77731dbcb853fddd21a3d3b23e27d8b8219/_next/";